/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { formatMessage } from "devextreme/localization";
import LoadPanel from "devextreme-react/load-panel";
import notify from "devextreme/ui/notify";
import Form, { Label, StringLengthRule } from "devextreme-react/form";
import {
  IsPermisionPathRequired,
  getLeaveApproval,
} from "../../../redux/actions";
import { responseMiddleware, responseLeave } from "../../../redux/reducers";
import { useScreenSize } from "../../../utils/media-query";
import { Item } from "devextreme-react/toolbar";
import LeaveApprovalTable from "./LeaveApprovalTable";
import "./style.scss";
import UsingIntl from "../../../services/using_intl";
import { postApproval } from "../../../services/approval";
import { useAuth } from "../../../contexts/auth";

import { getStatusApproval, getCurrentPath } from "../../../common";
import PopupConfig from "../../../common/popup";

export default function LeaveApprovalList() {
  const { isXSmall, isSmall } = useScreenSize();
  const history = useHistory();
  const { user } = useAuth();
  const { handleOpenPopup, handleClosePopup, popupConfig } = PopupConfig();
  const { middlewarePath: middleware, loading: middlewareLoading } =
    useSelector(responseMiddleware);
  const currentPath = getCurrentPath();
  const { leaveApproval } = useSelector(responseLeave);
  const dispatch = useDispatch();
  const formData = useRef({});
  let dataGrid = useRef(null);

  const [filter, setFilter] = useState({
    Status: null,
    FromDate: null,
    ToDate: null,
    EmployeeOid: user?.EmployeeOid,
  });

  useEffect(() => {
    dispatch(IsPermisionPathRequired(currentPath));
    UsingIntl("P0013");
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { ReadState, NavigateState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (ReadState !== undefined && !ReadState)
      ) {
        history.push("/403");
        return;
      }
    }
  }, [middleware]);

  useEffect(() => {
    const getData = async () => {
      const state = getStatusApproval(window.location.href);
      setFilter({ ...filter, Status: state });
    };
    getData();
  }, []);

  const handleChangeSelectBox = async () => {
    const newPayload = {
      ...filter,
      Status: filter.Status !== null ? `${filter.Status}` : null,
    };
    dispatch(getLeaveApproval(newPayload));
  };

  useEffect(() => {
    handleChangeSelectBox();
  }, [filter.Status]);

  const handleSendApprove = async (data) => {
    let payload = {
      EmployeeOid: filter.EmployeeOid,
    };
    if (data.Oid || data.items) {
      payload = {
        ...payload,
        ApprovalStatus: 1,
        Transactions: data.items ? data.items : [data],
      };
    } else {
      payload = {
        ...payload,
        ...formData.current,
        Transactions: popupConfig.data.items
          ? popupConfig.data.items
          : [popupConfig.data],
      };
    }
    try {
      await postApproval(payload, "ApproveLeave", {
        headers: {
          MappedState: 6,
        },
      });
      handleClosePopup();
      handleChangeSelectBox();
      dataGrid.current.instance.refresh();
      notify("Successfully updated", "success", 2000);
    } catch (error) {
      handleChangeSelectBox();
      notify(error.response.data.message, error.response.data.msgType, 3000);
    }
  };

  const renderViewPopup = () => {
    formData.current.ApprovalStatus = popupConfig.data.type;
    formData.current.Comment = "";
    return (
      <Popup
        visible={popupConfig.popupVisible}
        onHiding={handleClosePopup}
        title={
          popupConfig.data.type === 1
            ? formatMessage("PopupTitleApprove")
            : formatMessage("PopupTitleReject")
        }
        showTitle={true}
        width={isSmall || isXSmall ? "100%" : "550px"}
        height={isSmall || isXSmall ? "400px" : "400px"}
        borderRadius={10}
        closeOnOutsideClick={false}
      >
        <Form formData={formData.current}>
          <Item dataField="Comment" editorType="dxTextArea">
            <StringLengthRule max="250" />
            <Label text={formatMessage("Comment")} />
          </Item>
        </Form>
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleSendApprove}
          options={{
            icon: "save",
            type: "success",
            text: formatMessage("Save"),
          }}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleClosePopup}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Cancel"),
          }}
        />
      </Popup>
    );
  };

  return (
    <div>
      <LoadPanel visible={middlewareLoading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("LeaveApproval")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/leave-registration/list" className={"breadcrumb-item"}>
            {formatMessage("Leave")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("LeaveApproval")}
          </span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          {popupConfig.popupVisible && renderViewPopup()}

          <LeaveApprovalTable
            dataGrid={dataGrid}
            middleware={middleware}
            handleOpenPopup={handleOpenPopup}
            approvalList={leaveApproval}
            handleChangeSelectBox={handleChangeSelectBox}
            filter={filter}
            setFilter={setFilter}
            handleSendApprove={handleSendApprove}
          />
        </div>
      </div>
    </div>
  );
}
